import React from 'react';

const IconPaymentDefault: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.038 0.5H35.962C36.8114 0.5 37.5 1.18859 37.5 2.038V21.962C37.5 22.8114 36.8114 23.5 35.962 23.5H2.038C1.18859 23.5 0.5 22.8114 0.5 21.962V2.038C0.5 1.18859 1.18859 0.5 2.038 0.5Z"
      fill="#E5E5E5"
      stroke="#E5E5E5"
    />
    <rect y="5" width="38" height="8" fill="#999999" />
  </svg>
);

export default IconPaymentDefault;
